import { useCallback } from 'react';
import { useAuthLogoutMutation, useIsObserver, useObserverEndMutation } from '@platform/features/auth';
import { useAppDispatch } from '@platform/state/hooks';
import { devUserChanged } from '@platform/state/slices/sessionSlice';
import { authRoutes } from './authRoutes';
import { useEnterApp } from './useEnterApp';

/**
 * «Вийти» (меню профілю): завершує сесію спостерігача, якщо вона триває, і сесію входу (POST /auth/logout — сервер очищає cookie), скидає
 * Dev-користувача й кеш API та відкриває вхід із порожніми полями (прототип v4 signOutTop). Помилка мережі вихід не зупиняє.
 */
export function useSignOut(): () => void {
  const dispatch = useAppDispatch();
  const observer = useIsObserver();
  const [logout] = useAuthLogoutMutation();
  const [endObserver] = useObserverEndMutation();
  const enter = useEnterApp();
  return useCallback(() => {
    const ended = observer ? endObserver().unwrap().catch(() => undefined) : Promise.resolve();
    void ended.then(() => logout().unwrap().catch(() => undefined)).finally(() => {
      dispatch(devUserChanged(null));
      enter(authRoutes.login(), { signedOut: true });
    });
  }, [dispatch, observer, logout, endObserver, enter]);
}
